import styles from "./styles.module.scss";

export const BotaoAcessibilidade = ({ clicar }) => {
    return (
        <div className={styles.sidebarContainer}>
            <button
                className={styles.acessibilidadeBtn}
                onClick={clicar}
                title="Acessibilidade"
                type="button"
            >
                
                <span className={styles.texto} style={{ textAlign: "left", flex: 1 }}>
                    ACESSIBILIDADE
                </span>
                <span className={`material-symbols-sharp ${styles.icone}`}>
                    accessibility_new
                </span>
            </button>
        </div>
    );
};